'use strict';

import { setupClickDropdown, resizeLoginDropdown, closeDropdown } from '../lib/dropdown';

const $ = require('jquery');
const ajaxInjection = require('./../modules/ajaxInjector.js');



function setupLogoutEvent () {
    $('a.logout').on('click', function (event) {
        event.preventDefault();

        ajaxInjection.request(
            '/ajax/login/logout',
            'POST',
            '',
            '.submenu.icon.login',
        ).then(function () {
            window.location.reload();
        });
    });
}
setupLogoutEvent();






function validateForm (postData) {
    return fetch('/ajax/login/checkForm', {
        method: 'POST',
        body: postData,
    })
        .then(r => r.json())
        .then(response => {
            if ( response.header.code !== 200 ) {
                throw(response.data);
            }
        });
}

function loginCustomer (postData) {
    return fetch('/ajax/login/loginCustomer', {
        method: 'POST',
        body: postData,
    })
        .then(r => r.json());
}

const afterLogin = loginFormSelector => responseData => {
    const response = responseData.data;

    if (response.login === true) {

        const template = require('./../template/header/loginSucces.hbs');
        const filledTemplate = template(response);
        $(loginFormSelector).html(filledTemplate);


        setupLogoutEvent();

        if (window.sPage === 'checkout' || window.sPage === 'cart') {
            window.location.reload();
        }

        if (window.sPage === 'customer') {
            window.location = '/account';
        }

        if ( response.customer && response.customer.firstName ) {
            const nameElem = document.querySelector('.submenu.login .name');
            if ( nameElem ) {
                nameElem.innerHTML = response.customer.firstName;
            }
        }

        const loginSubmenu = document.querySelector('.submenu.login');
        const loginSubmenuToggle = document.querySelector('.submenu.login .toggle');

        if ( loginSubmenu && loginSubmenuToggle ) {
            closeDropdown(loginSubmenu, loginSubmenuToggle)();
        }
    } else {
        throw(response);
    }
}

const loginErrorHandler = $form => response =>{
    $form.find('.email').empty();
    $form.find('.password').empty();

    if ( response.message ) {
        $form.find('.error').first().html(response.message);
    }

    if( typeof  response.message.email !== 'undefined'){
        $form.find('.email').append( '<p class="error">'+response.message.email+'<p>' );
    }

    if( typeof  response.message.password !== 'undefined'){
        $form.find('.password').append( '<p class="error">'+response.message.password+'<p>' );
    }
}



$('body').on('submit' ,'.login-form', function (e) {
    e.preventDefault();

    const loginFormSelector = e.target.closest('#checkout') === null
                            ? '.submenu.login .toggle'
                            : '#checkout .login.part .toggle';



    let postData = new FormData();
    postData.append('email', $(this).find('[name="email"]').val());
    postData.append('password', $(this).find('[name="password"]').val());
    postData.append('remember', $(this).find('[name="remember"]').is(':checked') ? 1 : 0);



    validateForm(postData)
        .then(() => loginCustomer(postData))
        .then(afterLogin(loginFormSelector))
        .catch(loginErrorHandler($(this)));
});

